import React from 'react';
import { useRouter } from 'next/router';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen} from '@fortawesome/free-solid-svg-icons';
import styles from '../../../styles/rca/rca.module.scss';
import sstyles from '../../../styles/rca/RCASummary.module.scss';
import { carSummaryFields, ownerSummaryFields, addressSummaryFields, driversSummaryFields, dntSummaryFields } from '../../search/summary/summaryFields';

const RCACompleteSummary = (props) => {
    const {vehicle, edit} = props;

    const router = useRouter();
    const isEditable = !edit || edit=='yes' ? true : false;


    const listFields = (fields) =>  { 
        return fields.map ( (f, i) =>
            <Row key={i} className={sstyles.row}>
                <Col xs="12" md="6" className={sstyles.info}>
                {f.label}
                </Col>
                <Col xs="12" md="6" className={sstyles.selection}>
                    {f.value}
                </Col>
            </Row>
        )};
    
    const editCar = () =>{
        router.push('/asigurari-rca/auto');
    }

    const editOwner = () =>{
        router.push('/asigurari-rca/proprietar');
    }

    const editAddress = () =>{
        router.push('/asigurari-rca/adresa');
    }

    const editDrivers = () =>{
        router.push('/asigurari-rca/conducatori');
    }

    const editDNT = () =>{
        router.push('/asigurari-rca/cerere');
    }

    const [autoSummaryData, autoDescription] =  vehicle ? carSummaryFields(vehicle.car) : [[], false];
    const [ownerSummaryData, ownerDescription] =  vehicle ? ownerSummaryFields(vehicle) : [[], false];
    const [addressSummaryData, addressDescription] =  vehicle ? addressSummaryFields(vehicle.address) : [[], false];
    const [driversSummaryData, driversDescription] =  vehicle ? driversSummaryFields(vehicle.drivers) : [[], false];
    const [dntSummaryData, dntDescription] =  vehicle ? dntSummaryFields(vehicle.cerere) : [[], false];

    const autoDetails = 
        <>
            <Row>
                <Col className={`${styles.title} green`}>
                    
                   { isEditable && <span className={``}>
                        <Button  variant="link" onClick={editCar}>
                            <FontAwesomeIcon icon={faPen} height={16} width={16} className="me-2"/>
                        </Button>
                    </span>
                    }
                    Autoturism
                </Col>
            </Row>
            {listFields(autoSummaryData)}
        </>;

    const ownerDetails = 
        <>
            <Row>
                <Col className={`${styles.title} green`}>
                    {isEditable && 
                    <span className={``}>
                        <Button  variant="link" onClick={editOwner}>
                            <FontAwesomeIcon icon={faPen} height={16} width={16} className="me-2"/>
                        </Button>
                    </span>
                    }
                    {vehicle.car.leasing == 'nu' ? 'Proprietar' : 'Utilizator' }
                </Col>
            </Row>
            {listFields(ownerSummaryData)}
        </>;

    const addressDetails = 
        <>
            <Row>
                <Col className={`${styles.title} green`}>
                    {isEditable && 
                    <span className={``}>
                        <Button  variant="link" onClick={editAddress}>
                            <FontAwesomeIcon icon={faPen} height={16} width={16} className="me-2"/>
                        </Button>
                    </span>
                    }
                    Adresa din talon
                </Col>
            </Row>
            {listFields(addressSummaryData)}
        </>;

    const driverDetails = 
        <>
            <Row>
                <Col className={`${styles.title} green`}>
                    {isEditable &&
                    <span >
                        <Button  variant="link" onClick={editDrivers}>
                            <FontAwesomeIcon icon={faPen} height={16} width={16} className="me-2"/>
                        </Button>
                    </span>
                    }
                    Conducatori auto
                </Col>
            </Row>
            {listFields(driversSummaryData)}
            
        </>;

    const dntDetails = 
        <>
            <Row>
                <Col className={`${styles.title} green`}> 
                {isEditable &&   
                    <span>
                        <Button  variant="link" onClick={editDNT}>
                            <FontAwesomeIcon icon={faPen} height={16} width={16} className="me-2"/>
                        </Button>
                    </span>
                }
                    Durata
                </Col>
            </Row>
            {listFields(dntSummaryData)}
        </>;

    return (

        <Col>
            {autoDetails}
            {ownerDetails}
            {addressDetails}
            {driverDetails}
            {dntDetails}
        </Col>
        
    );
}

export default RCACompleteSummary;